// extracted by mini-css-extract-plugin
module.exports = {"successText":"style_successText__Uogzu","doneButton":"style_doneButton__D7x8i"};